import { LatLng } from "use-places-autocomplete";
import { OrderTypesKeysEnum, ReceiptItemStateEnum } from "../../enums";
import {
  Address,
  AddressPlus,
  DeliveryConfigZone,
  DeliveryReceiptStatusEnum,
  Franchise,
  FranchiseDeliveryConfig,
  PaidReceipt,
} from "../../types";
import { pointInPolygon } from "../maths/maths";

export const checkAddressAvailabliltyInFranchisesV2 = (
  address: Address,
  franchises: Franchise[],
  franchiseSlug: string | string[] | undefined,
  currentDeliveryTypeId: number | undefined
) => {
  // // check if address is within current franchise
  const currentLocation = {
    lat: address.lat,
    lng: address.lng,
  };

  let isInCurrentFranchise = false;
  const availableDeliveryFranchises = [];
  let zoneConfig = null;
  if (currentDeliveryTypeId) {
    for (let index = 0; index < franchises.length; index++) {
      const franchiseCur = franchises[index];
      if (franchiseCur.franchiseConfig.deliveryV2) {
        // Check which franchise has delivery V2
        const franchiseDeliveryConfigCurr: FranchiseDeliveryConfig[] =
          franchiseCur.franchiseConfig.deliveryV2;

        const franchiseCurDeliveryConfig = franchiseDeliveryConfigCurr.find(
          (config) => config.deliveryType.id === currentDeliveryTypeId
        );
        // Check which franchise has same delivery type
        if (franchiseCurDeliveryConfig) {
          const inZone = inFranchiseDeliveryZoneV2(
            currentLocation,
            franchiseCurDeliveryConfig.deliveryConfigZones
          );
          if (inZone) {
            if (
              franchiseCur.slug === franchiseSlug ||
              (!franchiseCur.slug && !franchiseSlug)
            ) {
              isInCurrentFranchise = true;
              zoneConfig = inZone;
            } else {
              availableDeliveryFranchises.push(franchiseCur as Franchise);
            }
          }
        }
      }
    }
  }

  return {
    ...address,
    isInCurrentFranchise,
    availableDeliveryFranchises,
    zoneConfig,
  };
};

export const sortAddress = (a: AddressPlus, b: AddressPlus) => {
  if (a.isInCurrentFranchise && !b.isInCurrentFranchise) {
    return -2;
  } else if (
    !a.isInCurrentFranchise &&
    !b.isInCurrentFranchise &&
    a.availableDeliveryFranchises.length > 0 &&
    b.availableDeliveryFranchises.length === 0
  ) {
    return -1;
  } else {
    return 1;
  }
};

export const inFranchiseDeliveryZoneV2 = (
  center: LatLng,
  deliveryZones: DeliveryConfigZone[]
) => {
  let inZone = null;
  for (let index = 0; index < deliveryZones.length; index++) {
    const deliveryZone = deliveryZones[index].deliveryZone.polygon;
    const deliveryZoneInLatLng = deliveryZone.map((latlng: number[]) => {
      return { lat: latlng[0], lng: latlng[1] };
    });

    if (pointInPolygon(center, deliveryZoneInLatLng)) {
      inZone = {
        minEstimatedTime: deliveryZones[index].minEstimatedTime,
        maxEstimatedTime: deliveryZones[index].maxEstimatedTime,
        deliveryFees: deliveryZones[index].deliveryFees,
        deliveryZoneId: deliveryZones[index].deliveryZoneId,
      };
      break;
    }
  }

  return inZone;
};

export const isReceiptDeliveryPaidAndCompleted = (receipt: PaidReceipt) => {
  return !!(
    receipt.paid_at &&
    receipt.state === ReceiptItemStateEnum.COMPLETED &&
    receipt.orderType === OrderTypesKeysEnum.DELIVERYV2 &&
    receipt.deliveryReceipt &&
    receipt.deliveryReceipt.maxEstimatedTime
  );
};

export const isDeliveryReceiptOnItsWayAndDelivered = (receipt: PaidReceipt) => {
  return !!(
    receipt.paid_at &&
    receipt.orderType === OrderTypesKeysEnum.DELIVERYV2 &&
    receipt.deliveryReceipt &&
    receipt.deliveryReceipt.deliveryStatus ===
      DeliveryReceiptStatusEnum.DELIVERED &&
    !isDeliveryReceiptTimeDone(receipt)
  );
};

export const isDeliveryReceiptOnItsWay = (receipt: PaidReceipt) => {
  return !!(
    isReceiptDeliveryPaidAndCompleted(receipt) &&
    !isDeliveryReceiptTimeDone(receipt)
  );
};

export const isDeliveryReceiptTimeDone = (receipt: PaidReceipt) => {
  const completedAt = new Date(receipt.completedAt);
  const currentDate = new Date();
  const deliveryWindow = new Date(
    completedAt.getTime() +
      (receipt.deliveryReceipt?.maxEstimatedTime! + 15) * 60000
  );

  return !!(
    isReceiptDeliveryPaidAndCompleted(receipt) &&
    deliveryWindow.getTime() <= currentDate.getTime()
  );
};
